import { useRef, useState } from "react";
import { TableauViz } from "@tableau/embedding-api-react";

const TableauEmbedProgrammaticFiltering = ({ content }) => {
  const [isVizReady, setIsVizReady] = useState(false);

  const vizRef = useRef(null);

  const handleFirstInteractive = async () => {
    console.log("Tableau Viz is now interactive. ");
    setIsVizReady(true);
    window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));

    const viz = vizRef.current;
    const sheet = viz.workbook.activeSheet.worksheets[0];
    const filters = await sheet.getFiltersAsync();

    console.log(
      "AVAILABLE FILTERS ON THIS DASHBOARD:",
      filters.map((f) => ({
        name: f.fieldName,
        type: f.filterType,
        currentValues: f.appliedValues?.map((v) => v.value),
      })),
    );
  };

  return (
    <div className="relative h-full w-full">
      {content?.embedToken ? (
        <TableauViz
          ref={vizRef}
          src={content.embedUrl}
          token={content?.embedToken}
          toolbar="hidden"
          device="desktop"
          onFirstInteractive={handleFirstInteractive}
          height="100%"
          vizFilters={content?.filters}
          style={{
            height: "100%",
            width: "100%",
            opacity: isVizReady ? 1 : 0,
            transition: "opacity 0.4s ease-in-out",
          }}
        />
      ) : (
        <div className="flex h-[800px] items-center justify-center">
          <p className="text-gray-500">Generating secure access token...</p>
        </div>
      )}
    </div>
  );
};

export default TableauEmbedProgrammaticFiltering;
